import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import DocumentationImagesController from 'views/Kits/components/DocumentationImagesController';
import {connect} from 'react-redux';

const mapStateToProps = (state, ownProps) => {
  return {};
};

const KitDocumentationImagesController = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
  },

  contextTypes: {
    kitToken: PropTypes.string.isRequired,
  },

  mixins: [ImmutableRenderMixin],

  render() {
    return (
      <DocumentationImagesController shareable={true} kitToken={this.context.kitToken} />
    );
  },
});

export default connect(mapStateToProps)(KitDocumentationImagesController);



// WEBPACK FOOTER //
// ./app/javascript/views/ShareResource/components/KitDocumentationImagesController.js